import { useState } from 'react';
import { reviews } from '@/mocks/manga';

export default function ReviewSection() {
  const [currentReview, setCurrentReview] = useState(0);

  const goToReview = (index: number) => {
    setCurrentReview(index);
  };

  const review = reviews[currentReview];

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="text-center mb-8">
        <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">
          REVIEWS
        </p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
          读者热评
        </h2>
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="bg-background-50 rounded-2xl p-6 md:p-8">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center gap-1 bg-foreground-900 text-background-50 text-xs font-semibold px-3 py-1 rounded-full">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {review.rating}.0
            </span>
            <span className="text-xs text-foreground-500">· {review.mangaTitle}</span>
          </div>

          <blockquote className="font-heading text-base md:text-lg text-foreground-800 leading-relaxed mb-5">
            &ldquo;{review.content}&rdquo;
          </blockquote>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
              <img
                src={review.avatar}
                alt={review.userName}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-800">{review.userName}</p>
              <p className="text-xs text-foreground-500">{review.date}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mt-6">
          <button
            onClick={() => goToReview((currentReview - 1 + reviews.length) % reviews.length)}
            className="w-8 h-8 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-600 hover:bg-foreground-100 transition-colors cursor-pointer"
            aria-label="Previous review"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>
          {reviews.map((_, i) => (
            <button
              key={i}
              onClick={() => goToReview(i)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                i === currentReview ? 'bg-accent-500 w-5' : 'bg-foreground-300'
              }`}
              aria-label={`Review ${i + 1}`}
            />
          ))}
          <button
            onClick={() => goToReview((currentReview + 1) % reviews.length)}
            className="w-8 h-8 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            aria-label="Next review"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}